import {Injectable} from '@angular/core';
import * as SockJS from 'sockjs-client';
import * as Stomp from 'stompjs';

@Injectable({
    providedIn: 'root',
})
export class StompService {

    socket = new SockJS('https://grafiniadesign.ro:9191/api/our-websocket');
    stompClient = Stomp.over(this.socket);

    connecting = false;
    topicQueue = [];

    subscribe(topic: string, callback: any) {


        // If stomp client is currently connecting add the topic to the queue
        if (this.connecting) {
            this.topicQueue.push({
                topic,
                callback
            });
            return;
        }


        const connected: boolean = this.stompClient.connected;
        // If there is a stomp client connection, just subscribe to topic
        if (connected) {
            this.connecting = false;
            this.subscribeToTopic(topic, callback);
            return;
        }

        // If stomp client is not connected, connect and subscribe to topic
        this.connecting = true;
        this.stompClient.connect({}, () => {
            this.subscribeToTopic(topic, callback);

            // Once we are connected loop the queue and subscribe to remaining topics from it
            this.topicQueue.forEach((item: any) => {
                this.subscribeToTopic(item.topic, item.callback);
            });

            // Once done empty the queue
            this.topicQueue = [];
        });

        // Set Custom interval for heartbeat
        this.stompClient.heartbeat.incoming = 20000;
        this.stompClient.heartbeat.outgoing = 20000;

        // Remove the debug console messages
        this.stompClient.debug = null;
    }

    subscribeToTopic(topic: string, callback: any) {
        this.stompClient.subscribe(topic, (response): any => {
            
            
            
            callback(response);
        });
    }
}
